<div class="col-12">
  <div class="col-12 d-flex align-itens-center title">
    <span class="mx-2" [ngClass]="[icone, classIcone]" *ngIf="icone"></span>
    <h1 class="fw-semibold m-0" [ngClass]="fontSizeTitle">{{ titulo }}</h1>
  </div>
  <div class="col-12 ms-1 ps-5" *ngIf="subTitulo">
    <p [ngClass]="fontSizeSubTitle">{{ subTitulo }}</p>
  </div>
</div>
